// Permisos efectivos del usuario, tal como vienen en el JWT (`permissions`:
// string[] con claves canónicas "recurso:acción"). Es solo un espejo para
// decidir qué mostrar: la autorización real la hace cada microservicio, así
// que ante un dato ausente o malformado el resultado es SIEMPRE "no tiene"
// (falla cerrado).

/**
 * @param {{ permissions?: unknown } | null | undefined} user usuario del contexto de auth
 * @param {string} key clave canónica, p. ej. "role:read"
 * @returns {boolean}
 */
export function hasPermission(user, key) {
  if (!key || !Array.isArray(user?.permissions)) return false;
  return user.permissions.includes(key);
}

/**
 * Claims de RBAC de un JWT ya decodificado, normalizados: sin `permissions`
 * array → [] (falla cerrado) y sin `customRole` → null.
 * @param {{ permissions?: unknown, customRole?: unknown } | null | undefined} decoded
 */
export function rbacClaimsFromToken(decoded) {
  return {
    permissions: Array.isArray(decoded?.permissions) ? decoded.permissions : [],
    customRole: decoded?.customRole ?? null,
  };
}

/**
 * ¿Tiene AL MENOS UNO de los permisos? Una lista vacía es false: pedir
 * "cualquiera de ninguno" nunca debe habilitar nada.
 * @param {{ permissions?: unknown } | null | undefined} user
 * @param {string[]} keys
 * @returns {boolean}
 */
export function hasAnyPermission(user, keys) {
  if (!Array.isArray(keys) || keys.length === 0) return false;
  return keys.some((key) => hasPermission(user, key));
}
